import type { ReactNode } from 'react';

export const symbol_language_french: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M168.5-288.63Q160-297.25 160-310v-340q0-12.75 8.63-21.38Q177.25-680 190-680h220q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220v120h150q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220v130q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm360 0Q520-297.25 520-310v-340q0-12.75 8.63-21.38Q537.25-680 550-680h190q24.75 0 42.38 17.62Q800-644.75 800-620v120q0 24.94-17.5 42.47Q765-440 740-440h-26l63 116q8 15-.5 29.5T751-280q-8.34 0-15.17-4T725-296l-78-144h-67v130q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM580-500h160v-120H580v120Z"
		/>
	</svg>
);
